<template>
  <div class="news-headlines-detail">
        <!-- <newsHeader :page='3'></newsHeader> -->
        <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="0"></Header> -->
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/list/testing' }">历年试卷</el-breadcrumb-item>
            <el-breadcrumb-item>{{article.title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-detail-wrapper main flex-between">
            <div class="news_detail_left">
                <div class="content-box">
                    <div class="title-box">
                        <h3 class="f18">{{article.title}}</h3>
                        <p class="source f12">{{article.source}}</p>
                        <div class="summary f12 flex-align-between">
                            <div class="box">
                                <span>{{article.createTime}}</span>
                                <span class="eye">{{article.views}}</span>
                            </div>
                            <!-- <div class="qrcode-box"> -->
                                <!-- <span>分享给好友</span> -->
                                <!-- <div class="qrcode" id="qrcode" ref="qrcode"></div> -->
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="content" v-html="article.content">
                         <!-- <p>
                             为全力做好疫情防控及应急处置工作，切实保障师生员工的健康和安全，
                            6月5日上午，我校组织开展学生返校演练。学校返校复课领导小组组长、
                            党委书记郑萼、校长孟繁华，领导小组成员、副校长杨志成、纪委书记李中奇、
                            副校长李有增、副校长马力耕、北京教育系统疫情防控工作领导小组驻我校联络员于杰进行观摩。
                            演练由党委副书记缪劲翔主持。
                        </p>
                        <p>
                            首先，孟繁华作返校演练动员讲话。
                            他表示，此次演练是对近期学校疫情防控工作的整体考核，
                            也是全面做好返校复学工作的关键一环。全校各单位要提高政治站位，
                            扎实守好每一个关口，树立“演练即是实战”思想，摸清问题短板，不断完善流程。
                            各单位、全体师生员工要同心同德、齐心协力，层层压实责任，营造良好氛围，
                            强化联防联控机制，举全校之力，迎接学生“回家”。
                         </p> -->
                        <!-- <img src="" alt=""> -->
                    </div>
                   <!-- <div class="pagination flex-align-between">
                       <p class="pv wes" @click="toContent(prev)">上一篇：{{prev? prev.title : '无'}}</p>
                       <p class="next wes" @click="toContent(next)">下一篇：{{next? next.title :'无'}}</p>
                   </div> -->
                   
                </div>
            </div>
            <!-- <div class="news_detail_right">
                <div class="subtitle flex-align-between">
                    <h2 class="text text-first f16 flex-align">最新推荐</h2>
                </div>
                <div class="timeline-list">
                    <el-timeline>
                      <el-timeline-item
                        v-for="(activity, index) in activities"
                        :key="index"
                        type="primary"
                        color="#BEE3FF"
                        size="large"
                        :timestamp="activity.timestamp"
                        class="timeline-item">
                        <p class="f12 wes" @click="toDetail(activity)">{{handleTimeOne(activity.createTime)}}</p>
                        <p class="f12 wes-2" @click="toDetail(activity)">{{activity.introduction}}</p>
                      </el-timeline-item>
                    </el-timeline>
                </div>
            </div> -->
        </div>
                 <footer-view></footer-view>

  </div>
</template>

<script>
export default {
    data() {
        return {
        link:'',
        article:{},
        content:{},
        prev:{},
        next:{},
        activities: [{
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
          },
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
          },
          color: '#BEE3FF'
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
          },
          color: '#BEE3FF'
        }, {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师范大学“双优云桥',
          },
          color: '#BEE3FF'
        },
        {
          content: {
              time:'2020.06.03',
              text:'首都教育远程互助工程“北京-银川”“互联网+教育” 首都师京-银川”“互联京-银川”“互联京-银川”“互联范大学“双优云桥',
          },
          color: '#BEE3FF'
        }]
        }
    },
    watch: {
        '$route': function(to,from){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    },
    methods: {
        async GetContent(){
            // console.log(this.$route.params.id);
            let params = {
                id : this.$route.params.id
            }
            let resData = await Api.Home.getDetail(params)
            this.article = resData.data;
            // console.log(resData.data)
         },
        
         async GetArticleHead(){
            // console.log(this.$route.params.id);
            let params = this.$route.params.id
            let resData = await Api.Home.getArticleHead(params)
            this.article = resData.data;
            // console.log(resData.data)
         },

        async getHotlist() {
            let params = {
                type:16,
                isAsc:'desc',
                num:1,
                size:7,
            }
            let resData = await Api.Home.getArticleList(params);
            this.activities=resData.rows;
            // console.log(resData.rows)
        },

        async getPrevAndNext() {
            let params = this.$route.params.id
            let resData = await Api.Home.getPrevAndNext(params);
            this.prev = resData.data.previous
            this.next = resData.data.next
            // console.log(resData.data.next);
        },

        toContent(item){
            let msg = {id:item.articleId,type:item.type}
            this.$router.push('/list/learning/detail/'+item.articleId ,msg)
        
        },
        toDetail(item){
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
            let path = '/list/learning/detail/';
            let msg = {id:item.articleId,type:item.type}
            this.$router.push( path + item.articleId ,msg)
            }
            // switch (item.type) {
            //     case 1 : 
            //         path = '/list/course/detail/'
            //         break;
            //     case 16 : 
            //         path = '/list/information/detail/'
            //         break;
            //     case 17 : 
            //          path = '/list/elegant/detail/'
            //          break;
            // } 
            
            // this.$router.push( path + item.articleId ,msg)
        },
        qrcode () {
            // this.$nextTick(() => {
                let that = this;
                let qrcode = new that.QRCode('qrcode',{
                    width: 200, // 设置宽度，单位像素
                    height: 200, // 设置高度，单位像素
                    text: that.link  // 设置二维码内容或跳转地址
                })
            // })
        }
    },
    mounted(){
        this.GetContent();
        // this.GetArticleHead();
        // this.getHotlist();
        // this.getPrevAndNext() ;
        // this.$nextTick(() => {
        //     this.link = window.location.href;
        //     // this.link = 'http://cticb.lezhireading.com/#/detail/175';
        //     this.qrcode()
        //  })
         
    },

}
</script>

<style lang="less">
    @import "./less/news_headlines_detail.less";
</style>